import { Badge } from "@radix-ui/themes";
import { useFocused, useSelected } from "platejs/react";
import FontAwesome from "../../utilities/FontAwesome";

export function UnknownElementPlaceholder({ tagName }: { tagName: string }) {
  const selected = useSelected();
  const focused = useFocused();

  return (
    <Badge
      contentEditable={false}
      color={"gray"}
      variant={"soft"}
      size={"3"}
      title={"Edit in Raw HTML to view or change this content"}
      style={{
        userSelect: "none",
        cursor: "default",
        boxShadow: selected && focused ? "0 0 0 2px var(--focus-8)" : undefined,
      }}
    >
      <FontAwesome prefix={"fas"} name={"fa-triangle-exclamation"} />
      {`<${tagName}>`}
    </Badge>
  );
}
